module.exports = __webpack_public_path__ + "static/img/rank_181.1032bf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_181.png
// module id = I8vO
// module chunks = 1